import React from "react";
import ReactDOM from 'react-dom';
import "./Modal.css";

const DeleteConfirmationModal = ({ children, isOpen, onClose, onConfirm }) => {

    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <div className="delete-modal-overlay">
            <div className="modal-container">
                <div className="modal-body">{children}</div>
                <div className="delete-modal-footer">
                    <button className="delete-cancel-btn" onClick={onClose}>
                        Cancel
                    </button>
                    <button className="delete-confirm-btn" onClick={onConfirm}>
                        Delete
                    </button>
                </div>
            </div>
        </div>,
        document.getElementById('modal-root')
    );
};

export default DeleteConfirmationModal;
